/**
 * @file Delays execution for a fixed or random amount of time.
 */
const DEFAULT_DELAY_MS = 50;
const RANDOM_DELAY_MIN_MS = 100;
const RANDOM_DELAY_RANGE_MS = 500;

/**
 * Resolves after the given number of milliseconds.
 */
const wait = (ms = DEFAULT_DELAY_MS): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/**
 * Resolves after a random delay, to spread out a batch of requests.
 */
const waitRandom = (): Promise<void> => {
  const randomMs = Math.floor(Math.random() * RANDOM_DELAY_RANGE_MS) + RANDOM_DELAY_MIN_MS;

  const promise = wait(randomMs);

  return promise;
};

export { wait, waitRandom };
